import React from 'react'
import MaterialSymbol from '../material-symbol'

const CheckBoxOutlineBlank = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="check_box_outline_blank" {...props} />
))

CheckBoxOutlineBlank.displayName = 'CheckBoxOutlineBlank'

export default CheckBoxOutlineBlank
